import { useEffect, useState } from "react";
import styles from "./FeedbackForm.module.scss";
import clsx from "clsx";
import { Loader } from "../Loader/Loader";
import { useMachine, useActor } from "@xstate/react";
import { feedbackMachine } from "../../xstate/feedback.machine";
import { AuthState } from "../../xstate/auth.machine";
import { FaTelegramPlane } from "react-icons/fa";
import { DocsMachine } from "../../xstate/docs.machine";

export function FeedbackForm() {
	const [stateFeedback, sendFeedback] = useMachine(feedbackMachine);
	const [docsState] = useMachine(DocsMachine);
	const [stateAuth, sendAuth] = useActor(AuthState);
	const [isPolicy, setIsPolicy] = useState(false);
	const [policyDoc, setPolicyDoc] = useState(null);
	const [tradePointId, setTradePointId] = useState(null);

	useEffect(() => {
		const storedData = localStorage.getItem("editingTradePoint");
		console.log("storedData", storedData);
		if (storedData) {
			const { id, name, address } = JSON.parse(storedData);
			setTradePointId(id);
			sendFeedback({
				type: "SET_TRADE_POINT_ID",
				data: id,
			});

			const defaultMessage =
				`Вы хотите поменять реквизиты TT:\n` +
				`Название торговой точки: ${name || "не указано"}\n` +
				`Адрес: ${address || "не указан"}\n\n` +
				`Укажите, что нужно исправить:`;

			sendFeedback({
				type: "INPUT_MESSAGE",
				key: "message",
				data: defaultMessage,
			});
			localStorage.removeItem("editingTradePoint");
		}
	}, []);

	useEffect(() => {
		if (stateAuth.context?.email && stateAuth.context?.id) {
			sendFeedback({
				type: "INPUT_EMAIL",
				key: "email",
				data: stateAuth.context.email,
			});
			sendFeedback({
				type: "SET_USER_ID",
				data: stateAuth.context.id,
			});
		}
	}, [stateAuth]);

	useEffect(() => {
		const personalDataDoc = docsState.context.docs.find(
			doc => doc.type === "personal_data"
		);

		if (personalDataDoc) {
			setPolicyDoc(personalDataDoc.url);
		}
	}, [docsState]);

	return (
		<section className={clsx(styles.feedbackForm)}>
			<div className={styles.wrapper}>
				{stateFeedback.matches("send") && (
					<div className={"fullPageLoader"}>
						<Loader />
					</div>
				)}

				<h1>Обратная связь</h1>
				<p>
					Мы ценим ваше мнение. Свои вопросы, пожелания и комментарии вы можете
					направить нам, заполнив форму ниже или написав нам в{" "}
					<a href="https://t.me/Feedback_ZICTOP" target="_blank">
						Telegram
					</a>
					.
				</p>
				<p>
					Прием заявок осуществляется круглосуточно
					<br />
					Менеджер ответит вам в рабочие дни с 9:00 до 18:00 по МСК
				</p>
				{stateFeedback.matches("success") ? (
					<div className={styles.successMessage}>
						<p className={"h2"}>Ваше обращение отправлено</p>
						<button
							type="button"
							className={"btn btnPrimary"}
							onClick={() => sendFeedback({ type: "ONE_MORE" })}
						>
							Отправить еще одно
						</button>
					</div>
				) : (
					<form
						onSubmit={event => {
							event.preventDefault();
							sendFeedback({ type: "SUBMIT" });
						}}
					>
						{tradePointId && (
							<input type="hidden" name="tradePointId" value={tradePointId} />
						)}
						<div className="formRow">
							<label htmlFor="email">Ваш e-mail</label>
							<input
								id="email"
								type="email"
								value={stateFeedback.context.email}
								name="email"
								onChange={event => {
									sendFeedback({
										type: "INPUT_EMAIL",
										key: "email",
										data: event.target.value,
									});
								}}
							/>
							{stateAuth.context?.email && stateAuth.context?.id ? (
								<div className={styles.helperText}>
									Вы можете изменить email, если хотите получить ответ на другую
									почту
								</div>
							) : (
								<></>
							)}

							{stateFeedback.context.errorMessage.map(item => {
								return (
									item.emailError !== "" && (
										<div className={"errorMessage"} key={"errEmail"}>
											{item.emailError}
										</div>
									)
								);
							})}
						</div>
						<div className="formRow">
							<label htmlFor="message">Ваше сообщение</label>
							<textarea
								name="message"
								id="message"
								value={stateFeedback.context.message}
								onChange={event => {
									sendFeedback({
										type: "INPUT_MESSAGE",
										key: "message",
										data: event.target.value,
									});
								}}
							/>
							{stateFeedback.context.errorMessage.map(item => {
								return (
									item.messageError !== "" && (
										<div className={"errorMessage"} key={"errMsg"}>
											{item.messageError}
										</div>
									)
								);
							})}
						</div>
						<div className="forRow">
							<label htmlFor="images">Добавить фото или видео</label>
							<div className={styles.imagesContainer}>
								<div className={styles.imageInput}>
									<input
										name={"images"}
										id={"images"}
										type="file"
										accept="image/*,video/*"
										multiple
										onChange={event => {
											sendFeedback({
												type: "INPUT_FILES",
												data: event.target.files,
											});
										}}
									/>
								</div>
								{stateFeedback.context.files?.map(item => {
									return (
										<div className={styles.imagePreview} key={item.id}>
											{item.file.type.includes("video") ? (
												<img src={"/images/video-preview.jpg"} alt="" />
											) : (
												<img src={item.preview} alt="" />
											)}

											<button
												type={"button"}
												className={styles.delete}
												onClick={() =>
													sendFeedback({
														type: "DELETE_FILE",
														data: item.id,
													})
												}
											>
												<svg
													width="26"
													height="26"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M3.646 3.646a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 0 1 .708.708L8.707 8l3.647 3.646a.5.5 0 0 1-.708.707L8 8.707l-3.646 3.647a.5.5 0 0 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708Z"
														fill="currentColor"
													/>
												</svg>
											</button>
										</div>
									);
								})}
							</div>
						</div>
						<div className={styles["field-group"]}>
							<label className={styles["field-label"]}>
								<input
									className={styles.checkbox}
									id="privacy_policy"
									name="privacy_policy"
									type="checkbox"
									checked={isPolicy}
									onChange={event => setIsPolicy(event.target.checked)}
								/>
								<span>
									Я ознакомлен(а) с{" "}
									<a href={policyDoc ?? ""} target="__blank">
										Политикой конфиденциальности
									</a>{" "}
									и согласен(сна) на обработку моих персональных данных в
									соответствии с{" "}
									<a href={policyDoc} target="__blank">
										Политикой конфиденциальности
									</a>
								</span>
							</label>
						</div>
						<div className="formRow">
							<button type={"submit"} className={"btn btnPrimary"}>
								Отправить
							</button>
						</div>
						{/* <div className="formRow">
                                <a className={styles.socialLink} href="https://t.me/+mSypn6W1gdUyNTM6" target="__blank">
                                    <FaTelegramPlane className={styles.telegramIcon} />
                                    Telegram чат ZIC ПРОФИ Вопрос/ответ
                                </a>
                            </div> */}
					</form>
				)}
			</div>
		</section>
	);
}
